module.exports = __webpack_public_path__ + "img/feature4.c2898922.jpg";